/* QOVA exact public cadence mapping. No price or customer-contract writes. */
(function(){
'use strict';
// Source IDs: Sep13 exact Shopify readback, public Recharge plans 21378656/7/8.
const PRODUCT = '9294946992342';
const VARIANT = '47962060456150';
const PLANS = Object.freeze({30: '7226523862', 60: '7514423510', 90: '7356022998'});
function qovaChange(item, frequency) {
  if (String(item?.product_id) !== PRODUCT) return null;
  if (String(item.variant_id) !== VARIANT || !item.key || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('QOVA cart line is not ready.');
  const current = item.selling_plan_allocation?.selling_plan?.id;
  if (current && !Object.values(PLANS).includes(String(current))) throw new Error('This QOVA plan needs to be managed separately.');
  const plan = PLANS[String(frequency)];
  if (!plan) throw new Error('Choose a supported QOVA delivery interval.');
  // Do not replace properties or remove/re-add the line. Shopify retains them.
  return {id: item.key, quantity: item.quantity, selling_plan: plan};
}


let attempts = 0;
let pending = null;
function setControlsBusy(busy) {
  document.querySelectorAll('#rebuy-cart .product-qova select, #rebuy-cart .product-qova button').forEach(node=>{
    if(busy && !node.disabled){node.dataset.qovaCadenceDisabled='1';node.disabled=true;}
    else if(!busy && node.dataset.qovaCadenceDisabled==='1'){node.disabled=false;delete node.dataset.qovaCadenceDisabled;}
  });
}
function showError(message) {
  let node=document.getElementById('qova-cadence-error');
  const cart=document.getElementById('rebuy-cart');
  if(!node && cart){node=document.createElement('p');node.id='qova-cadence-error';node.setAttribute('role','alert');node.style.cssText='padding:12px 20px;margin:0;color:#8b1a1a;background:#fff;';(cart.querySelector('.rebuy-cart__flyout-body')||cart).prepend(node);}
  if(node)node.textContent=message;
}
function normalizeOptions() {
  const smart=window.Rebuy && window.Rebuy.SmartCart;
  if(!smart || typeof smart.subscriptionFrequencies!=='function' || smart.subscriptionFrequencies.qovaPublicOptions)return;
  const original=smart.subscriptionFrequencies;
  function publicOptions(item) {
    if(String(item && item.product_id)===PRODUCT && String(item.variant_id)===VARIANT)return [30,60,90];
    return original.apply(this,arguments);
  }
  publicOptions.qovaPublicOptions=true;
  smart.subscriptionFrequencies=publicOptions;
}

function install() {
  const cart=window.Rebuy && window.Rebuy.Cart;
  if(!cart || typeof cart.switchItemToFrequency!=='function' || typeof cart.changeItem!=='function' || typeof cart.getItems!=='function') return false;
  if(cart.switchItemToFrequency.qovaExactPlans){normalizeOptions();return true;}
  const original=cart.switchItemToFrequency;
  function exactQova(item,frequency,success,error) {
    if(String(item && item.product_id)!==PRODUCT) return original.apply(this,arguments);
    if(pending) {
      if(typeof error==='function')error();
      item.status='updating';
      if(item.product)item.product.subscription_frequency=pending.frequency;
      setControlsBusy(true);
      showError('Your cart is still updating. Please wait a moment before making another change.');
      return;
    }
    // The native queue is serialized: never enqueue a stale quantity/key behind
    // a quantity, gift or removal request already in progress.
    if(cart.process || !Array.isArray(cart.queue) || cart.queue.length || cart.status!=='ready') {
      if(typeof error==='function')error();
      showError('Your cart is still updating. Please wait a moment before making another change.');
      return;
    }
    if(String(frequency)==='onetime')return original.apply(this,arguments);
    const fail=()=>{pending=null;setControlsBusy(false);item.status='ready';showError('We could not update your delivery interval. Please refresh your cart and try again.');if(typeof error==='function')error();};
    try {
      const fresh=cart.getItems().find(line=>line.key===item.key);
      if(!fresh || fresh.quantity!==item.quantity) return fail();
      const payload=qovaChange(fresh,frequency);
      const current=fresh.selling_plan_allocation && fresh.selling_plan_allocation.selling_plan.id;
      if(String(current)===payload.selling_plan){item.status='ready';if(typeof success==='function')success();return;}
      const message=document.getElementById('qova-cadence-error');if(message)message.textContent='';
      pending={key:item.key,frequency:Number(frequency)};
      item.status='updating';setControlsBusy(true);
      cart.changeItem(payload,{success:function(){pending=null;setControlsBusy(false);const note=document.getElementById('qova-cadence-error');if(note)note.textContent='';item.status='ready';if(typeof success==='function')success();},error:fail});
    } catch(err) {fail();}
  }
  exactQova.qovaExactPlans=true;
  cart.switchItemToFrequency=exactQova;
  normalizeOptions();
  return true;
}
function tryInstall(){if(install())return;if(++attempts<100)setTimeout(tryInstall,100);}
document.addEventListener('rebuy.ready',install);
document.addEventListener('rebuy:cart.ready',install);
document.addEventListener('rebuy:smartcart.init',normalizeOptions);
document.addEventListener('rebuy:smartcart.ready',normalizeOptions);
tryInstall();

})();
